import b from 'b_';
import React from 'react';

import './rounded-plate__divider.scss';

export enum DIVIDER_VIEW {
    INVISIBLE = 'invisible',
    DEFAULT = 'default',
}

interface Props {
    view: DIVIDER_VIEW;
}

const RoundedPlateDivider = ({ view = DIVIDER_VIEW.DEFAULT }: Props) => (
    <div className={b('rounded-plate', 'divider', { view })} />
);

export default RoundedPlateDivider;
